import { render, staticRenderFns } from "./BaseBadge.vue?vue&type=template&id=5e31e63a&"
import script from "./BaseBadge.vue?vue&type=script&lang=ts&"
export * from "./BaseBadge.vue?vue&type=script&lang=ts&"
import style0 from "./BaseBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports